import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AttendanceMain from '../Attendancemain/AttendanceMain'; // Fixed path casing
import AttendanceSettings from '../Attendancemain/AttendanceSettings';
import MonthlyReports from '../Attendancemain/MonthlyReports';
import Corrections from '../Attendancemain/Corrections';

function Attendance() {
  return (
    <Routes>
      {/* Default route for attendance */}
      <Route path="/" element={<AttendanceMain />} />

      {/* Settings page */}
      <Route path="settings" element={<AttendanceSettings />} />

      {/* Monthly reports */}
      <Route path="monthly-reports" element={<MonthlyReports />} />

      {/* Corrections */}
      <Route path="corrections" element={<Corrections />} />

      {/* Redirect any other paths within attendance to the daily-records alias */}
      <Route path="/daily-records" element={<AttendanceMain />} /> 
    </Routes>
  );
}

export default Attendance;